import { siteStats, quickEntries } from '@/mocks/home';

const iconTones = [
  'bg-primary-100 text-primary-700',
  'bg-secondary-100 text-secondary-700',
  'bg-accent-100 text-accent-700',
];

const hotSearches = ['分账争议', '加盟纠纷', '剪辑争议', '票房数据', '退票风波'];

export default function EntryHero() {
  return (
    <section id="entry" className="relative overflow-hidden bg-background-100 border-b border-background-200">
      <div className="pointer-events-none absolute -top-24 -right-24 w-72 h-72 rounded-full bg-primary-100/70 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-32 -left-24 w-80 h-80 rounded-full bg-accent-100/50 blur-3xl"></div>

      <div className="relative max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid lg:grid-cols-12 gap-8 md:gap-12 items-center">
          <div className="lg:col-span-7 animate-fadeUp">
            <span className="inline-flex items-center gap-2 h-7 pl-1 pr-3 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-700">
              <span className="w-5 h-5 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-flashlight-fill text-background-50 text-[11px]"></i>
              </span>
              持续跟进中 · 今日新增 128 条
            </span>

            <h2 className="mt-5 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950 text-balance">
              每一条瓜，
              <span className="text-primary-600">都拆成看得懂的脉络</span>
            </h2>

            <p className="mt-4 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
              糖心小桃黑料与爆料事件集中地，瓜、争议、扒皮、实锤持续跟进。我们把散落的截图、回应与关键时间点归到同一个事件里，帮你理清事件脉络，看到不同角度的说法，再决定自己信哪一边。
            </p>

            <div id="top" className="mt-7 w-full rounded-lg border border-background-200 bg-background-50 p-2 md:p-2.5">
              <div className="flex flex-col sm:flex-row items-stretch gap-2">
                <label className="flex-1 flex items-center gap-2.5 h-11 px-3.5 rounded-md bg-background-100 border border-background-200 focus-within:border-primary-300 transition-colors">
                  <i className="ri-search-2-line text-primary-500 text-lg"></i>
                  <input
                    type="text"
                    placeholder="输入事件名、账号名或关键词，直接进入整理页"
                    className="w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
                  />
                </label>
                <button
                  type="button"
                  className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-1.5"
                >
                  <i className="ri-arrow-right-up-line text-base"></i>
                  开始查看
                </button>
              </div>
              <div className="flex flex-wrap items-center gap-x-4 gap-y-1 px-1.5 pt-2.5 pb-1 text-xs">
                <span className="text-foreground-500">热门搜索</span>
                {hotSearches.map((item) => (
                  <a key={item} href="#hot" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                    {item}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative max-w-md mx-auto lg:mx-0 lg:ml-auto">
              <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20peach%20and%20coral%20toned%20editorial%20abstract%20still%20life%20on%20a%20cream%20background%2C%20layered%20paper%20shapes%20and%20soft%20fabric%20folds%2C%20gentle%20studio%20lighting%2C%20subtle%20film%20grain%2C%20premium%20magazine%20cover%20aesthetic%2C%20calm%20harmonious%20composition%2C%20high%20detail%2C%20no%20text&width=1400&height=900&seq=peach-hero-2026-01&orientation=landscape"
                  alt="糖心小桃事件整理与脉络追踪"
                  title="糖心小桃事件整理与脉络追踪 黑料爆料瓜争议扒皮实锤"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="absolute -bottom-6 -left-4 w-36 md:w-44 aspect-square rounded-lg overflow-hidden border-4 border-background-100 hidden sm:block animate-floatSlow">
                <img
                  src="https://readdy.ai/api/search-image?query=Blush%20pink%20and%20cream%20editorial%20abstract%20detail%20with%20folded%20matte%20paper%20and%20a%20small%20ceramic%20object%2C%20soft%20diffused%20daylight%2C%20fine%20grain%20texture%2C%20refined%20magazine%20aesthetic%2C%20quiet%20balanced%20composition%2C%20high%20detail%2C%20no%20text&width=700&height=700&seq=peach-hero-2026-02&orientation=squarish"
                  alt="事件封面整理"
                  title="事件封面整理 糖心小桃爆料实锤"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="absolute top-4 right-4 flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50 border border-background-200">
                <i className="ri-fire-fill text-primary-500"></i>
                <span className="text-xs text-foreground-700 font-label">今日最热 · 98.6万</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {quickEntries.map((entry, index) => (
            <a
              key={entry.label}
              href="#hot"
              className="group rounded-lg border border-background-200 bg-background-50 p-3.5 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <span className={`w-9 h-9 rounded-md flex items-center justify-center ${iconTones[index % iconTones.length]}`}>
                  <i className={`${entry.icon} text-lg`}></i>
                </span>
                <span className="text-xs font-label text-foreground-400">{entry.count}</span>
              </div>
              <div className="mt-3 text-sm font-medium text-foreground-900 group-hover:text-primary-700 transition-colors">
                {entry.label}
              </div>
            </a>
          ))}
        </div>

        <div className="mt-3 md:mt-4 grid grid-cols-2 md:grid-cols-4 gap-3">
          {siteStats.map((stat) => (
            <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 px-4 py-3.5">
              <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">{stat.value}</div>
              <div className="mt-1 text-xs text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}